/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  SWITCH_BOTTOM_SHEET,
  ACTIVE_BOTTOM_SHEET_SUBMIT_BUTTON,
  NAV_BAR_SWIPER_EXPANDED,
} from '../../constants/actionType'

/**
 * Declare Variable
 */
const switchBottomSheetAction = createAction(SWITCH_BOTTOM_SHEET)
const activeBottomSheetSubmitButtonAction = createAction(ACTIVE_BOTTOM_SHEET_SUBMIT_BUTTON)
const navBarSwiperExpandAction = createAction(NAV_BAR_SWIPER_EXPANDED)

/**
 * Export
 */
export const switchBottomSheet = (params) => (dispatch) => {
  try {
    dispatch(switchBottomSheetAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const activeBottomSheetSubmitButton = (params) => (dispatch) => {
  try {
    dispatch(activeBottomSheetSubmitButtonAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateNavBarSwiperExpand = (params) => (dispatch) => {
  try {
    dispatch(navBarSwiperExpandAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/stepper.js